import { icons } from "helpers/images";

const SocialMediaIcons = ({ message, url = "https://zynerd.com" }) => {
  const platforms = [
    {
      name: "WhatsApp",
      icon: icons.whatsapp,
      link: `https://api.whatsapp.com/send?text=${message}`,
    },
    {
      name: "Facebook",
      icon: icons.instituteInfoFacebook,
      link: `https://www.facebook.com/sharer/sharer.php?u=${encodeURI(
        url
      )}&quote=${encodeURIComponent(message)}`,
    },
    {
      name: "X",
      icon: icons.instituteInfoX,
      link: `https://twitter.com/intent/tweet?text=${message}`,
    },
    {
      name: "Telegram",
      icon: icons.instituteInfoTelegram,
      link: `https://telegram.me/share/url?text=${encodeURI(message)}&url=${encodeURI(url)}`,
    },
  ];

  return (
    <div className="flex flex-wrap justify-center gap-4 landing-md:gap-8 mt-6">
      {platforms.map((platform, idx) => (
        <a
          key={idx}
          className="flex flex-col items-center text-sm font-medium text-gray-700 cursor-pointer"
          href={platform.link}
          target="_blank"
        >
          <img
            src={platform.icon}
            alt={platform.name}
            className="h-8 w-8 landing-md:h-10 landing-md:w-10 mb-1"
          />
          {platform.name}
        </a>
      ))}
    </div>
  );
};

export default SocialMediaIcons;
